import React from 'react';
import { TemplateWrapper, TemplateName, TemplateParam } from './MessageTemplate.styled';

type MessageTemplateProps = { name?: string; params?: string[] };

export function MessageTemplate({ name, params }: MessageTemplateProps) {
  if (!name && (!params || params.length === 0)) return null;
  return (
    <TemplateWrapper>
      {name && <TemplateName>📋 {name}</TemplateName>}
      {params?.map((param, i) => (
        <TemplateParam key={i}>• {param}</TemplateParam>
      ))}
    </TemplateWrapper>
  );
}
